import CurrencyIcon from '@/components/ui/icons/currency-icon';
import NextImage from '@/components/ui/next-image';
import QtyControlBtns from '@/components/cart/QtyControlBtns';
import DeleteCartItem from '@/components/ui/buttons/delete-cart-item';
import { handlePriceByComma } from '@/helpers/common';
import NextLink from '@/components/next-link';

const MiniCartItem = ({ image, name, price, href, quantity, item_id }) => {
  return (
    <li className='flex items-start gap-2.5 border-b py-3.5 pe-1 first:pt-0 last:border-b-0 last:pb-1'>
      <NextImage
        src={image}
        alt={name}
        className='h-24 w-24 rounded-md border object-cover'
        width={96}
        height={112}
        loading='lazy'
      />

      <div className='flex flex-1 flex-col items-start justify-between text-sm'>
        <NextLink
          href={href}
          title={name}
          className='line-clamp-2 font-semibold'
        >
          {name}
        </NextLink>

        <p className='mb-1.5 flex items-center gap-1 font-bold'>
          {handlePriceByComma(price)}
          <CurrencyIcon className='size-3.5' />
        </p>
        <QtyControlBtns
          quantity={quantity}
          item_id={item_id}
          fromPopup={true}
        />
      </div>
      <DeleteCartItem item_id={item_id} />
    </li>
  );
};

export default MiniCartItem;
